import { getTenantId, removeProtocol, getUrlProtocol } from '@/mixins/Helpers'

export const BASE_IMAGE_URL = getUrlProtocol(import.meta.env.VITE_APP_IMAGE_API_URL) + "//" + getTenantId() +  removeProtocol(import.meta.env.VITE_APP_IMAGE_API_URL)
export const BASE_URL = getUrlProtocol(import.meta.env.VITE_APP_API_URL) + "//" + getTenantId() + removeProtocol(import.meta.env.VITE_APP_API_URL)
export const DEFAULT_URL = getUrlProtocol(import.meta.env.VITE_APP_API_URL) + "//" + removeProtocol(import.meta.env.VITE_APP_API_URL)
export const APP_URL = "http://" + getTenantId(import.meta.env.VITE_IGNORE_TENANT_ID) + removeProtocol(import.meta.env.VITE_APP_HOST) + ':' + import.meta.env.VITE_APP_PORT


